import React from "react";

function ChangePassword() {
  return <div></div>;
}

export default ChangePassword;
